module.exports = __webpack_public_path__ + "02_long_black.abf05c36.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/02_long_black.png
// module id = Nywz
// module chunks = 0